import { render } from "./HomeInfo.vue?vue&type=template&id=629808d0&scoped=true"
import script from "./HomeInfo.vue?vue&type=script&lang=js"
export * from "./HomeInfo.vue?vue&type=script&lang=js"

import "./HomeInfo.vue?vue&type=style&index=0&id=629808d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-629808d0"]])

export default __exports__